import React, { forwardRef } from 'react';

import Row from 'components/Editor/blocks/Table/Row';
import Cell from 'components/Editor/blocks/Table/Cell';

const Table = forwardRef(({ children, ...attributes }, ref) => {
	return (
		<table className="border-collapse table-fixed w-full">
			<tbody ref={ref} {...attributes}>
				{children}
			</tbody>
		</table>
	);
});

export {
	Table,
	Row,
	Cell
};